// eslint-disable-next-line
// @ts-nocheck

import { teasers as T } from '../teasers';
import { PageBlockTypes as p } from '@xprog/prensa/types'

import { addRelativeWidthToTeaser } from './utils'

export const LayoutMostRead: p.SlotConfigProps = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        default: [T.TeaserMostRead, T.TeaserMostRead]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        default: [T.TeaserMostRead, T.TeaserMostRead]
      }
    },
    TemplateSideBoxFixed: {
      slotLeft: {
        default: [T.TeaserMostReadFixed, T.TeaserMostReadFixed]
      },
      slotCenter: {
        default: [T.TeaserMostReadFixed, T.TeaserMostReadFixed]
      }
    }
  }
}